import { builtinFormatters } from "cayo.ui";

export function multilineFormatter(value?: string) {
  const result = builtinFormatters.html(value || "").replace(/\r\n|\r|\n/g, "<br/>");
  return result;
}
